import { useStripePromise } from "@Light/app/stripe";
import {
  PaymentSession,
  PaymentSessionContext,
} from "@Light/components/page/payment/PaymentSession";
import { Elements } from "@stripe/react-stripe-js";
import { useContext } from "react";

export type StripeElementsProps = {
  children: React.ReactNode;
};

/**
 * Wraps children in a Stripe `<Elements>` provider, ensuring a
 * `<PaymentSession>` ancestor is present. If a payment session is already
 * provided higher in the tree it is reused rather than creating a second one,
 * so this can be dropped in whether or not that context already exists.
 */
export const StripeElements: React.FC<StripeElementsProps> = ({ children }) => {
  const paymentSession = useContext(PaymentSessionContext);
  const stripePromise = useStripePromise();

  if (!paymentSession) {
    return (
      <PaymentSession>
        <StripeElements>{children}</StripeElements>
      </PaymentSession>
    );
  }

  return (
    <Elements
      stripe={stripePromise}
      options={{
        clientSecret: paymentSession.client_secret,
        appearance: {
          disableAnimations: true,
          variables: {
            borderRadius: "48px",
          },
        },
      }}
    >
      {children}
    </Elements>
  );
};
